import React, {useEffect} from 'react'
//import { useSelector } from 'react-redux'; //remove
import { useEyeconxStore } from '../../../../store/eyeconxStore'
const ElementTheme = () => {
   // const survey = useSelector((state)=>state.survey)
   const {survey} = useEyeconxStore()
   
    useEffect(()=>{
        console.log("survey in object")
        console.log(survey)
    },[survey])
    return ( 
        <>
           <pre>{JSON.stringify(survey,null,2)}</pre> 
        </>
     );
}
 
export default ElementTheme;